import styled from "styled-components";

export const MusicHallRegisNumberGuestStyled = styled.div`
  /* หน้าตรวจสอบข้อมูล (disabled) พื้นเทาเหมือน dropdown/textarea ให้รู้ว่าแก้ไม่ได้
     แก้เฉพาะฟอร์มขั้นตอนจองห้อง ไม่แตะ TextField กลางที่ใช้อีกหลายหน้า */
  input:disabled {
    background: ${({ theme }) => theme.COLORS.GRAY_6};
  }
  .textfield_layout {
    margin-bottom: 32px;
    .textfield_text1 {
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
    .textfield_text2 {
      margin-bottom: 10px;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
    }
  }
  .button_layout {
    padding: 0px 42px;
    display: flex;
    justify-content: center;
    column-gap: 36px;
    .button1 {
      flex: 1;
    }
    .button2 {
      flex: 1;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    .button_layout {
      padding: 0;
      display: flex;
      column-gap: 16px;
    }
  }
`;
